// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29GVy","col":"styles_col__2Wl83"};